import React from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { IconButton } from 'swag-client-common/components/ui/icon-button';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import { ProductFavouriteButton } from '../../../../../../../page/components/product-favourite-button';
import rightToLeftAnimationClasses from '../../right-to-left.anim.scss';
import classes from '../../tools-panel.scss';
export const TopBar = ({
  onShowWarning,
  onDesignSave,
  onClickShareDesign,
  onClickAddToStore,
  noSelectedLogos,
  isTopButtonsShown,
  isOutOfStock,
  isFavourite = true,
  productId,
  onProductFavouriteClick,
  isLoggedIn,
  isAddStoreShown
}) => {
  const changeFavouriteStatus = () => {
    onProductFavouriteClick({
      productId: productId,
      nextIsFavourite: !isFavourite
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.editingToolsShown, classes.fixedOnTop)
  }, !isOutOfStock && /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: rightToLeftAnimationClasses,
    in: isTopButtonsShown,
    unmountOnExit: true,
    timeout: 250
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: noSelectedLogos ? onShowWarning : onDesignSave,
    tooltipDirection: "bottom",
    dataTooltip: "Save design",
    iconClassName: classes.saveDesign,
    buttonClassName: classnames(classes.paddedButton, classes.scaleButton),
    ariaLabel: "Save design"
  })), !isOutOfStock && /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: rightToLeftAnimationClasses,
    in: isTopButtonsShown,
    unmountOnExit: true,
    timeout: 250
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: noSelectedLogos ? onShowWarning : onClickShareDesign,
    tooltipDirection: "bottom",
    dataTooltip: "Share design",
    iconClassName: classes.shareDesign,
    buttonClassName: classnames(classes.paddedButton, classes.scaleButton),
    ariaLabel: "Share design"
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: rightToLeftAnimationClasses,
    in: isAddStoreShown,
    unmountOnExit: true,
    timeout: 250
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClickAddToStore,
    tooltipDirection: "bottom",
    dataTooltip: "Add to store",
    iconClassName: classes.addToStore,
    buttonClassName: classnames(classes.paddedButton, classes.scaleButton),
    ariaLabel: "Add to store"
  })), /*#__PURE__*/React.createElement(IconButton, {
    tooltipDirection: "bottom",
    dataTooltip: isFavourite ? 'Remove from favorites' : 'Add to favorites',
    buttonClassName: classnames(classes.paddedButton, classes.scaleButton, classes.onlyTabletOrDesktop),
    customChild: /*#__PURE__*/React.createElement(ProductFavouriteButton, {
      className: classes.favButton,
      disableChangingState: !isLoggedIn,
      onClick: value => {
        onProductFavouriteClick({
          productId: productId,
          nextIsFavourite: value
        });
      },
      isFavourite: isFavourite,
      tabIndex: -1
    }),
    ariaLabel: isFavourite ? 'Remove from favorites' : 'Add to favorites',
    onKeyDown: e => handleOnEnterPressed(e, changeFavouriteStatus)
  }));
};